
import React, { createContext, ReactNode, useContext } from "react";

export type SidebarProps = {
  isSideBarOpen: boolean;
  setIsSideBarOpen: React.Dispatch<React.SetStateAction<boolean>>;
};
export const SidebarContext = createContext<SidebarProps | null>({} as SidebarProps);

export function useSidebar() {
  const ctx = useContext(SidebarContext);
  return ctx;
}
export default function SidebarProvider({
  value,
  children,
}: {
  value: SidebarProps;
  children: ReactNode;
}): JSX.Element {
  return (
    <SidebarContext.Provider value={value}>{children}</SidebarContext.Provider>
  );
}
